import Vue from 'vue';
import cart from '../../api/cart.js';
import * as types from '../mutation-types';

// initial state
const state = {
  amount_with_modifiers_normal: 0,
  amount_with_modifiers_normal_after_coupon: 0,
  amount_with_modifiers_partial: 0,
  amount_with_modifiers_partial_after_coupon: 0,
  cart: [],
  shipping_list: [],
  selected_shipping: {}
};

// getters
const getters = {
  cart: (state) => {
    return state.cart;
  },
  amount_with_modifiers_normal: (state) => {
    return state.amount_with_modifiers_normal.toFixed(2);
  },
  amount_with_modifiers_normal_after_coupon: (state) => {
    return state.amount_with_modifiers_normal_after_coupon.toFixed(2);
  },
  amount_with_modifiers_partial: (state) => {
    return state.amount_with_modifiers_partial.toFixed(2);
  },
  amount_with_modifiers_partial_after_coupon: (state) => {
    return state.amount_with_modifiers_partial_after_coupon.toFixed(2);
  },
  visitor_modifiers: (state) => {
    return state.visitor_modifiers;
  },
};

// actions
const actions = {
  set_shipping ({ commit, state }, shipping) {
    commit(types.SET_SHIPPING, shipping);
  },

  init_shipping ({ commit }, { module_id }) {
    return cart.shipping_list(module_id, (shipping_list) => {
      if (shipping_list.length) {
        commit(types.SET_SHIPPING, shipping_list[0]);
      }
      commit(types.SET_SHIPPING_LIST, shipping_list);
    }, (response) => {

    });
  },

  init_checkout ({ commit, state }) {
    commit(types.CHECKOUT_INIT);
  },
  init_cart ({ commit, state, rootState }, module_id) {
    cart.getCart(rootState.Module.visitor_id, module_id,
      (response) => {
        commit(types.CART_REPLACE, response.data);
      }, (response) => {
      }
    );
  },

  delete_item ({commit, state, rootState}, cart_id) {
    cart.deleteCartItem(cart_id,
      (response) => {
        commit(types.CART_REPLACE, response.data);
      },
      (response) => {}
    );
  },

  update_quantity ({commit, state, rootState}, payload) {
    cart.updateQuatity(payload,
      (response) => {
        commit(types.CART_REPLACE, response.data);
      },
      (response) => {}
    );
  },

  apply_coupon ({commit, state, rootState}, parameters) {
    cart.applyCoupon(rootState.Module.active_module.module_id, rootState.Module.visitor_id, parameters.code, (response) => {
      console.log('response', response);
      if (response.data.status === 'OK') {
        cart.getCart(rootState.Module.visitor_id, rootState.Module.active_module.module_id,
          (response) => {
            commit(types.CART_REPLACE, response.data);
          }, (response) => {
          }
        );
      }
    }, (response) => {
    });
  },
  remove_coupon ({commit, state, rootState}, parameters) {
    cart.removeCoupon(rootState.Module.active_module.module_id, rootState.Module.visitor_id, parameters.code, (response) => {
      console.log('response', response);
      if (response.data.status === 'OK') {
        cart.getCart(rootState.Module.visitor_id, rootState.Module.active_module.module_id,
          (response) => {
            commit(types.CART_REPLACE, response.data);
          }, (response) => {
          }
        );
      }
    }, (response) => {
    });
  }
};

// mutations
const mutations = {
  [types.CHECKOUT_INIT] (state) {
    // clear cart
    state.added = [];
    state.checkoutStatus = null;
  },

  [types.SET_SHIPPING] (state, data) {
    state.selected_shipping = data;
  },

  [types.SET_SHIPPING_LIST] (state, data) {
    state.shipping_list = data;
  },

  [types.CART_REPLACE] (state, data) {
    // console.log('CART_REPLACE', data);
    Vue.set(state, 'cart', data.data.items);
    Vue.set(state, 'visitor_modifiers', data.data.visitor_modifiers);
    Vue.set(state, 'amount_with_modifiers_normal', data.data.total_regular);
    Vue.set(state, 'amount_with_modifiers_normal_after_coupon', data.data.total_regular_after_coupons);
    Vue.set(state, 'amount_with_modifiers_partial', data.data.total_partial);
    Vue.set(state, 'amount_with_modifiers_partial_after_coupon', data.data.total_partial_after_coupons);
  },
};

export default {
  state,
  getters,
  actions,
  mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/Cart.js